import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guard/auth.guard';
import { LayoutComponent } from './layout/layout.component';
import { LoginGuard } from './guard/login.guard';
import { Error404Component } from './pages/error404/error404.component';
import { Error403Component } from './pages/error403/error403.component';

const routes: Routes = [
  {
    path: 'admin', component: LayoutComponent,// Se renderiza rutas protegidas en la plantilla
    canActivate:[AuthGuard],
    canActivateChild:[AuthGuard],
    children: [
      { path: '',loadChildren: () => import('./modulos/admin/admin.module').then(m => m.AdminModule) },
      { path: '',loadChildren: () => import('./modulos/catalogos-proces/catalogos-proces.module').then(m => m.CatalogosProcesModule) },
      { path: '',loadChildren: () => import('./modulos/catalogos-admin/catalogos-admin.module').then(m => m.CatalogosAdminModule) },
      { path: '',loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule) },
      { path: '',loadChildren: () => import('./modulos/elementos-plan/elementos-plan.module').then(m => m.ElementosPlanModule) },  
      { path: '',loadChildren: () => import('./modulos/reportes-plan/reportes-plan.module').then(m => m.ReportesPlanModule) },    
    ]
  },
  { path: 'login',
    canActivate :[LoginGuard],
    loadChildren: () => import('./modulos/auth/auth.module').then(m => m.AuthModule)
  },

  {path: 'pagina403',component: Error403Component},
  {path: '**', component: Error404Component,},  
  //{path: '',redirectTo: 'admin/dashboard', pathMatch:'full'},  
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)

  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
